<template>
<div class="modal fade in" id="modal-default" role="alertdialog" :hidden="!conditional">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" data-dismiss="modal" :aria-label="$options.filters.translate('close')" @click="close">
					<span aria-hidden="true">×</span>
				</button>
			</div>
			<div class="modal-body text-center">
				<h4 class="modal-title">{{ titleHead | translate | capitalize }}</h4>
				<p class="modal-text">{{ message | translate | capitalize }}</p>
			</div>
			<div class="modal-footer">
				<form @submit.prevent="confirm"  class="form-poll-status">
					<div class="form__group submit__content">
						<button type="submit">
							{{ buttonText | translate | capitalize  }}
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
</template>
<script>

	export default {
		name: 'modal-generic',
		props: {
			conditional: {
				type: Boolean,
				required: true,
			},
			buttonText: {
				type: String,
				required: false,
				default: 'Confirm',
			},
			message: {
				type: String,
				required: false,
			},

			titleHead: {
				type: String,
				required: false,
			},
		},
		data() {
			return {
				modalShow: this.conditional,
			};
		},

		methods: {
			close() {
				this.modalShow = this.conditional;
				this.$emit('close', false);
			},
			confirm() {
				this.$emit('confirm', 'ignore');
				this.modalShow = !this.conditional;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/modal/modalGeneric.vue